"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useDialog2 = _interopRequireDefault(require("../hooks/useDialog2"));

require("./QdLearningQuestionContainer");

var _QdLearningView = _interopRequireDefault(require("../views/QdLearningView"));

var _constants = require("../definitions/constants");

var _TypeToReactComponent = require("../helpers/TypeToReactComponent");

var exampleQuestion1 = {
  id: "Autorenhandreichung_01",
  type: "QD",
  questionText: "id 1",
  answers: ["Der Flüssigkeitsstand liegt zwischen der Min-Max-Markierung", "Fühlen, ob der Behälter schön kühl ist", "Die Farbe der Kühlflüssigkeit prüfen", "Der Motor ist auch nach der Fahrt kalt"],
  timelimit: 10,
  correctAnswer: [0],
  feedback: "",
  detailedFeedback: {},
  shuffle: true,
  inlineimg: false,
  points: 1
};
var exampleJson = {
  type: _constants.DIALOG_TYPES.INITIAL,
  preconditions: [],
  subDialogs: [{
    type: _constants.DIALOG_TYPES.SERIES,
    preconditions: [{
      type: _constants.PRECONDITION_TYPE.SHOW,
      active: false,
      conditions: []
    }],
    subDialogs: [{
      type: _constants.DIALOG_TYPES.QUESTION,
      preconditions: [{
        type: _constants.PRECONDITION_TYPE.SHOW,
        active: true,
        conditions: [["curDialogIndex == 0"]]
      }],
      subDialogs: [{
        type: _constants.DIALOG_TYPES.PROMPT,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          text: "Prompt for dialogIndex 0"
        }
      }, {
        type: _constants.DIALOG_TYPES.ANSWER,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          answers: ["0 answer for dialogIndex 0", "1 answer for dialogIndex 0", "2 answer for dialogIndex 0", "3 answer for dialogIndex 0"]
        }
      }]
    }, {
      type: _constants.DIALOG_TYPES.QUESTION,
      preconditions: [{
        type: _constants.PRECONDITION_TYPE.SHOW,
        active: true,
        conditions: [["curDialogIndex == 1", "lastAnswerWasCorrect == true"]]
      }],
      subDialogs: [{
        type: _constants.DIALOG_TYPES.PROMPT,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          text: "Prompt for dialogIndex 1, lastAnswerWasCorrect == true"
        }
      }, {
        type: _constants.DIALOG_TYPES.ANSWER,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          answers: ["0 answer for dialogIndex 1", "1 answer for dialogIndex 1", "2 answer for dialogIndex 1", "3 answer for dialogIndex 1"]
        }
      }]
    }, {
      type: _constants.DIALOG_TYPES.QUESTION,
      preconditions: [{
        type: _constants.PRECONDITION_TYPE.SHOW,
        active: true,
        conditions: [["curDialogIndex == 1", "lastAnswerWasCorrect == false"]]
      }],
      subDialogs: [{
        type: _constants.DIALOG_TYPES.PROMPT,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          text: "Prompt for dialogIndex 1, lastAnswerWasCorrect == false"
        }
      }, {
        type: _constants.DIALOG_TYPES.ANSWER,
        preconditions: [{
          type: _constants.PRECONDITION_TYPE.SHOW,
          active: false,
          conditions: []
        }],
        subDialogs: [],
        props: {
          answers: ["0 answer for dialogIndex 1", "1 answer for dialogIndex 1", "2 answer for dialogIndex 1", "3 answer for dialogIndex 1"]
        }
      }]
    }, {
      //todo: feedback based on history of previous answers ?
      type: _constants.DIALOG_TYPES.PROMPT,
      preconditions: [{
        type: _constants.PRECONDITION_TYPE.SHOW,
        active: true,
        conditions: [["curDialogIndex == 2"]]
      }],
      subDialogs: [],
      props: {
        text: "Prompt for dialogIndex 2"
      }
    }]
  }]
};

function _default(props) {
  //todo: add types for the return values of the hooks
  var _useDialog = (0, _useDialog2["default"])(exampleJson),
      readySubDialogs = _useDialog.readySubDialogs;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentSubDialogs = _useState2[0],
      setCurrentSubDialogs = _useState2[1];

  (0, _react.useEffect)(function () {
    //todo: selection stuff
    var tempCurrentSubDialogs = [];
    readySubDialogs.forEach(function (dialog) {
      tempCurrentSubDialogs.push(dialog);
    });
    setCurrentSubDialogs(tempCurrentSubDialogs);
  }, [readySubDialogs]);
  return /*#__PURE__*/_react["default"].createElement(_QdLearningView["default"], null, currentSubDialogs.map(function (dialog) {
    return (0, _TypeToReactComponent.getComponent)(dialog);
  }));
}